import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import cx from "classnames";

import logo from "assets/images/hl-tw.png";
import TOT from "assets/images/tot/TOT.png";
import logoTot from "assets/images/hl-tot.png";
import logoOCH from "assets/images/hl-chpt.png";
import Eye from "assets/images/verboden/Eye.png";
import sbsLogo from "assets/images/hl-white.png";
import GAH_Logo from "assets/images/gah_logo.png";
import PoweredImage from "assets/images/giphy.png";
import GAH_Logo_main from "assets/images/hl-gah.png";
import logoLight from "assets/images/hl-verboden.png";
import bingo_logo from "assets/images/bingo/Bingo.png";
import GameApart_Logo from "assets/images/hl-bingo.png";
import tw_logo from "assets/images/tw/the-word-logo.png";
import TWHeylimeLogo from "assets/images/tw/tw-heylime.png";
import slidekick_logo from "assets/images/heylime-logo.png";
import {
  default as logoDw20,
  default as logoWhite
} from "assets/images/hl-white.png";
import charty_party_logo from "assets/images/charty-party/charty-party-logo.png";
import VolumeSBS from "../../smallBites/VolumeSBS";

export default (props) => {
  const game_code = useSelector(
    (state) => state.gameReducer?.roomObj?.game_code
  );
  let roomData = props.roomData;
  const {
    className = "",
    verboden = false,
    tot = false,
    dw20 = false,
    OCH = false,
    GAH = false,
    TW = false,
    CHPT = false,
    CT = false,
    slideKick = false,
    BNG = false,
    SBS = false
  } = props;

  const gameTitle = props.gameTitle;
  if (
    (roomData && Object.keys(roomData).length > 0) ||
    verboden ||
    tot ||
    BNG ||
    dw20 ||
    OCH ||
    GAH ||
    SBS ||
    TW ||
    CHPT ||
    CT ||
    slideKick
  ) {
    return (
      <header
        id="header"
        className={cx(`${className} ${game_code}`, {
          darkHeader: verboden || GAH || props.GAH,
          verboden,
          tot,
          dw20,
          OCH,
          TW,
          CHPT,
          CT,
          BNG,
          slideKick,
          SBS
        })}
      >
        <Container fluid>
          <div className="headerWrapper">
            <div className="logo-wrapper gah-logo-wrap">
              {(game_code === "LT" || game_code === "LTS") && <VolumeSBS />}

              <Link to="/">
                <img
                  src={
                    dw20
                      ? logoDw20
                      : BNG
                      ? GameApart_Logo
                      : tot
                      ? logoTot
                      : GAH || props.GAH
                      ? GAH_Logo_main
                      : OCH
                      ? TW
                      : BNG
                      ? logoOCH
                      : CT
                      ? logoWhite
                      : verboden
                      ? logoLight
                      : CHPT
                      ? logoOCH
                      : SBS
                      ? ""
                      : slideKick
                      ? slidekick_logo
                      : TW
                      ? TWHeylimeLogo
                      : logo
                  }
                  alt=""
                  className={`logo  ${game_code}`}
                />
              </Link>
            </div>

            <div className="headerTitle">
              {TW && <img src={tw_logo} alt="logo" />}
              {CT && <h3>CONSPIRACY THEORY</h3>}
              {BNG && <img src={bingo_logo} alt="logo" />}
              {SBS && <img src={sbsLogo} className="sbsLogo mr-1" alt="eye" />}
              {verboden && (
                <h1 className="vb-title">
                  <img src={Eye} className="mr-1" alt="eye" />
                  {gameTitle}
                </h1>
              )}
              {tot && (
                <h1 className="tot-title">
                  <img src={TOT} alt="logo" />
                </h1>
              )}
              {slideKick && (
                <div className="slidekick-header-title"> SlideKick</div>
              )}
              {!verboden &&
                !tot &&
                !GAH &&
                !CHPT &&
                !TW &&
                !CT &&
                !BNG &&
                !SBS &&
                !slideKick && <h1>{gameTitle}</h1>}
              {GAH && (
                <img
                  className="header-img gah-img"
                  src={GAH_Logo}
                  alt="powered"
                />
              )}
              {CHPT && (
                <img
                  className="header-img"
                  src={charty_party_logo}
                  alt="powered"
                />
              )}
              {roomData?.game_code === "CHPT" && (
                <img
                  className="header-img gah"
                  src={charty_party_logo}
                  alt="powered"
                />
              )}
              {(GAH || roomData?.game_code === "GAH") && (
                <div
                  className={cx("powered-img", {})}
                  style={
                    props.TW
                      ? {
                          right: "-200%"
                        }
                      : slideKick
                      ? { right: "-177%" }
                      : CT
                      ? { right: "-177%" }
                      : GAH
                      ? { right: "-85%" }
                      : { right: "-125%" }
                  }
                >
                  <img src={PoweredImage} alt="powered" />
                </div>
              )}
            </div>
            <div className="blank-div" />

            {CHPT && (
              <div className="giphy">
                <button
                  className={props.how_to_play ? "disabled-chpt" : ""}
                  disabled={props.how_to_play}
                  onClick={() => props.toggleHowToPlay(false)}
                >
                  {props?.how_to_play_title}
                </button>
              </div>
            )}
          </div>
        </Container>
      </header>
    );
  } else {
    return <></>;
  }
};
